import { Guid } from "@/types"

export interface IGetMaintenanceTypeDto {
    id: Guid
    name: string
}

export interface ICreateMaintenanceTypeDto {
    name: string
}

export default class MaintenanceType {
    id: Guid
    name: string

    constructor(dto: IGetMaintenanceTypeDto) {
        this.id = dto.id
        this.name = dto.name
    }
}
